const redirectToUrl = (url) => window.location.assign(url);

export default redirectToUrl;
